import React from 'react';
import LoginPage from './LoginPage';

/** Login is available on desktop and mobile. */
export default function LoginRoute() {
  return <LoginPage />;
}
